import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useAuth0 } from "@auth0/auth0-react";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    user,
    isAuthenticated,
    loginWithRedirect,
    logout,
  } = useAuth0();
  const toggle = () => setIsOpen(!isOpen);

  const logoutWithRedirect = () => {
    sessionStorage.removeItem('token');
    logout({
      returnTo: window.location.origin,
    });
  }

  const roles = user != null && user["http://exoticcartrader.com/role"];

  return (
    <div className="nav-container" style={{ width: '100%' }}>
      <Navbar color="light" light expand="md">
        <Container>
          <NavbarBrand className="logo" />
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                >
                  Home
                </NavLink>
              </NavItem>
              {isAuthenticated && roles.includes("Photographer") && (
                <NavItem>
                  <NavLink
                    to="/my-shoots"
                    end
                    className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                  >
                    My Shoots
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && (roles.includes("Editor") || roles.includes("Blogger")) && (
                <NavItem>
                  <NavLink
                    to="/jobs"
                    // end
                    className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                  >
                    Available Jobs
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && (roles.includes("Editor") || roles.includes("Blogger")) && (
                <NavItem>
                  <NavLink
                    to="/my-jobs"
                    end
                    className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                  >
                    My Jobs
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && roles.includes("Photography Manager") && (
                <NavItem>
                  <NavLink
                    to="/shoots"
                    end
                    className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                  >
                    Manage Shoots
                  </NavLink>
                </NavItem>
              )}
              {isAuthenticated && roles.includes("Photography Manager") && (
                <NavItem>
                  <NavLink
                    to="/photographer-search"
                    end
                    className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                  >
                    Photographer Search
                  </NavLink>
                </NavItem>
              )}
            </Nav>
            <Nav className="d-none d-md-block" navbar>
              {!isAuthenticated && (
                <NavItem>
                  <Button
                    id="qsLoginBtn"
                    color="primary"
                    className="btn-margin"
                    onClick={() => loginWithRedirect({ redirectUri: process.env.REACT_APP_APP_ORIGIN + "/redirect" })}
                  >
                    Log in
                  </Button>
                </NavItem>
              )}
              {isAuthenticated && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret id="profileDropDown">
                    <img
                      src={user.picture}
                      alt="Profile"
                      className="nav-user-profile rounded-circle"
                      width="50"
                    />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header>{user.name}</DropdownItem>
                    <DropdownItem
                      tag={NavLink}
                      to="/profile"
                      className={ 'dropdown-profile'}
                    >
                      <FontAwesomeIcon icon="user" className="mr-3" /> Profile
                    </DropdownItem>
                    <DropdownItem
                      id="qsLogoutBtn"
                      onClick={() => logoutWithRedirect()}
                    >
                      <FontAwesomeIcon icon="power-off" className="mr-3" /> Log
                      out
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </Nav>
            {!isAuthenticated && (
              <Nav className="d-md-none" navbar>
                <NavItem>
                  <Button
                    id="qsLoginBtn"
                    color="primary"
                    block
                    onClick={() => loginWithRedirect({ redirectUri: process.env.REACT_APP_APP_ORIGIN + "/redirect" })}
                  >
                    Log in
                  </Button>
                </NavItem>
              </Nav>
            )}
            {isAuthenticated && (
              <Nav
                className="d-md-none justify-content-between"
                navbar
                style={{ minHeight: 170 }}
              >
                <NavItem>
                  <span className="user-info">
                    <img
                      src={user.picture}
                      alt="Profile"
                      className="nav-user-profile d-inline-block rounded-circle mr-3"
                      width="50"
                    />
                    <h6 className="d-inline-block">{user.name}</h6>
                  </span>
                </NavItem>
                <NavItem>
                  <FontAwesomeIcon icon="user" className="mr-3" />
                  <NavLink
                    to="/profile"
                    className={({ isActive }) => isActive? "router-link-exact-active nav-link": 'nav-link'}
                  >
                    Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <FontAwesomeIcon icon="power-off" className="mr-3" />
                  <NavLink
                    to="#"
                    id="qsLogoutBtn"
                    onClick={() => logoutWithRedirect()}
                  >
                    Log out
                  </NavLink>
                </NavItem>
              </Nav>
            )}
          </Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
